import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';

@Injectable()
export class PayrollRegisterReportProvider {

  private _service: string = 'payroll';
  private _model: string = 'payrollregisterreport';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public listRegisterPayroll(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'listRegisterPayroll';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public downloadRegisterPayroll(fileName: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadRegisterPayroll';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof fileName !== 'undefined' && fileName !== null) _urlParams.fileName = fileName;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlob(_method, _url, _func, _params, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/payroll-register-report/payroll-register-report.ts